import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"mb-7",attrs:{"fluid":""}},[_c(VRow,[_c('OverallPerformance',{attrs:{"external-user":true,"external-user-id":this.$store.state.shared.id,"external-user-name":this.$store.state.shared.firstName,"riskRewardRatio":_vm.riskRewardRatio,"trades":this.$store.state.book.trades,"winningRatio":_vm.winningRatio}})],1),_c(VDivider,{staticClass:"my-3 mr-3"}),_c(VRow,[_c('TradeList',{attrs:{"shared":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }